import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const-estilos";
import { crearOpcionRespuestaChecklist, modificarOpcionRespuestaChecklist } from "../../../api/checklist";
import "../../../style/style-cargando.css";

export default function OpcionesRespuesta() {
  const location = useLocation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [opcionRespuesta, setOpcionRespuesta] = useState(null);
  const [titulo, setTitulo] = useState("");

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setOpcionRespuesta(data.params);
        setTitulo(data.titulo);
      }
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const handleInputChange = (event) => {
    // console.log('handleInputChange');
    const { name, value } = event.target;
    // console.log(name);
    // console.log(value);
    setOpcionRespuesta({ ...opcionRespuesta, [name]: value });
  };

  const handleEnviarCorreo = (event) => {
    console.log('handleInputChange');
    const { name } = event.target;
    console.log(name);
    console.log(event.target.checked);
    setOpcionRespuesta({ ...opcionRespuesta, [name]: event.target.checked });
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    console.log('opcionRespuesta');
    console.log(opcionRespuesta);
    let objEnviar = {};
    objEnviar.descripcion = opcionRespuesta.descripcion;
    objEnviar.id = opcionRespuesta.id;
    objEnviar.color = opcionRespuesta.color;
    objEnviar.enviarcorreo = opcionRespuesta.enviarcorreo;
    if (opcionRespuesta.id <= 0) {
      // console.log('crear correo');
      let creado = await crearOpcionRespuestaChecklist(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (creado === true) {
        alert('Se creo correctamente');
        handleCancelClick();
      }
      if (creado === false) {
        alert('No se pudo crear');
      }
    }
    if (opcionRespuesta.id > 0) {
      // console.log('actualizar correo');
      let modificado = await modificarOpcionRespuestaChecklist(objEnviar);
      // console.log('modificado');
      // console.log(modificado);
      if (modificado === true) {
        alert('Se modifico correctamente');
        handleCancelClick();
      }
      if (modificado === false) {
        alert('No se pudo modificar');
      }
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginTop: 30,
            }}
          >
            <div className="loader"></div>
            <div
              style={{ marginTop: 10, }}
            >
              <p>Cargando...</p>
            </div>
          </div>
        );
      }
      if (cargandoPage === false && opcionRespuesta === null) {
        return (
          <div>
            <label> Sin data</label>
          </div>
        );
      }
      return (
        <div className="min-h-screen bg-gray-100 flex flex-col  py-12 sm:px-6 lg:px-8">
          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <h2 className="text-center text-3xl font-extrabold text-gray-900">
              {titulo}
            </h2>
            <div className="mt-6 bg-white py-6 px-4 shadow-md rounded-lg sm:px-10">
              <div className="space-y-6">
                <div>
                  <label
                    htmlFor="nombre"
                    className="block text-sm font-medium text-gray-700"
                  >
                    OPCION RESPUESTA
                  </label>
                  <div className="mt-1">
                    <input
                      id="descripcion"
                      name="descripcion"
                      type="text"
                      value={opcionRespuesta.descripcion}
                      onChange={handleInputChange}
                      autoComplete="given-name"
                      className={ESTILO_INPUT_GENERICO}
                      required
                      maxLength={127}
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="nombre"
                    className="block text-sm font-medium text-gray-700"
                  >
                    ELEGIR COLOR
                  </label>
                  <div className="mt-1">
                    <input
                      id="color"
                      name="color"
                      type="color"
                      value={opcionRespuesta.color}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="nombre"
                    className="block text-sm font-medium text-gray-700"
                  >
                    ENVIAR CORREO SI ESTA OPCION ES SELECCIONADA
                  </label>
                  <div className="mt-1">
                    <label className="switch">
                      <input
                        id="enviarcorreo"
                        name="enviarcorreo"
                        type="checkbox"
                        checked={opcionRespuesta.enviarcorreo}
                        onChange={handleEnviarCorreo}
                      />
                      <span className="slider round"></span>
                    </label>
                    <p>{opcionRespuesta.enviarcorreo ? "Si" : "No"}</p>
                  </div>
                </div>

                <div className="flex justify-end">
                  <div
                    style={{
                      justifyContent: 'space-between',
                      display: 'flex',
                      width: '100%'
                    }}
                  >
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_CANCELAR}
                      onClick={handleCancelClick}
                    >
                      Cancelar
                    </button>
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      onClick={handleSaveClick}
                    >
                      Aceptar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } catch (err) {
      console.log('ModificarCorreos render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
